// src/pages/about/AboutCounters.tsx
import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import axios from "axios";
import { t } from "../../../lang/index";

interface CounterData {
  label: string;
  icon: string;
  value: number;
  colorClass: string;
}

interface AboutStatsDTO {
  destinationsWorldwide: number;
  bookingsCompleted: number;
  clientsGlobally: number;
  providersRegistered: number;
}

const AboutCounters: React.FC = () => {
  const BASE_URL = process.env.REACT_APP_API_URL;

  // Carrega labels traduzidos
  const labels = t("home.aboutCounters") as any[];

  const [counters, setCounters] = useState<CounterData[]>([
    // fallback mock
    { ...labels[0], value: 50 },
    { ...labels[1], value: 7000 },
    { ...labels[2], value: 100 },
    { ...labels[3], value: 89 },
  ]);

  // Busca dados reais do backend
  useEffect(() => {
    const fetchCounters = async () => {
      try {
        const res = await axios.get<AboutStatsDTO>(`${BASE_URL}/public/abouts/counters`);
        const data = res.data;

        const mappedCounters: CounterData[] = [
          { ...labels[0], value: data.destinationsWorldwide },
          { ...labels[1], value: data.bookingsCompleted },
          { ...labels[2], value: data.clientsGlobally },
          { ...labels[3], value: data.providersRegistered },
        ];

        setCounters(mappedCounters);
      } catch (err) {
        console.error("Erro ao buscar counters:", err);
        // Mantém os mocks caso dê erro
      }
    };

    fetchCounters();
  }, [BASE_URL, labels]);

  return (
    <div className="counter-wrap">
      <div className="row">
        {counters.map((counter, idx) => (
          <div className="col-lg-3 col-md-6" key={idx}>
            <div className="counter-item mb-4">
              <h6 className={`mb-1 d-flex align-items-center justify-content-center ${counter.colorClass}`}>
                <i className={`isax ${counter.icon} me-2`}></i>
                {counter.label}
              </h6>
              <h3 className="display-6">
                <span className="counter">
                  <CountUp end={counter.value} />
                </span>
                +
              </h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutCounters;